import Product from "./Product";

export default function Fafpm({ product }){

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>FAFPM</span>
            </div>

            <div className="apply-option-row">
                <span>250€ pris en charge</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Dossier de prise en charge prêt à déposer sur votre compte FAFPM</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Accès immédiat</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Avance de frais</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Aucune contrainte de délai de complétion</span>
            </div>
            
        </Product>
}